// TODO: wrap this in `defineMessages`
const COPY = {
  FAQ_BASIC: {
    id: 'Pricing.copy.FaqBasic',
    defaultMessage: 'The Basic plan is FREE.',
    desc: '[Type: Text][Vis: high] - FAQ price display for BASIC plan',
  },
  FAQ_MONTHLY: {
    id: 'Pricing.copy.FaqMonthly',
    defaultMessage: 'The {packageName} plan costs {cost} a month.',
    desc: '[Type: Text][Vis: high] - FAQ price display for monthly plans',
  },
  FAQ_ANNUAL: {
    id: 'Pricing.copy.FaqAnnual',
    defaultMessage: 'The {packageName} plan costs {cost} a month, billed annually.',
    desc: '[Type: Text][Vis: high] - FAQ price display for individual annual plans',
  },
  FAQ_TEAMS: {
    id: 'Pricing.copy.FaqTeams',
    defaultMessage: 'The {packageName} plan costs {cost} a month, per user, billed annually.',
    desc: '[Type: Text][Vis: high] - FAQ price display for team plans',
  },
  // country specific overrides
  BR_FAQ_ANNUAL: {
    id: 'Pricing.copy.BrFaqAnnual',
    defaultMessage: 'The {packageName} plan costs {cost}, paid annually (up front).',
    desc: '[Type: Text][Vis: high] - Brazilian FAQ price display for individual annual plans',
  },
  BR_FAQ_TEAMS: {
    id: 'Pricing.copy.BrFaqTeams',
    defaultMessage: 'The {packageName} plan costs {cost}, paid annually for 3 users (up front).',
    desc: '[Type: Text][Vis: high] - Brazilian FAQ price display for team plans',
  },
};

export default COPY;
